import {
  ActionType,
  createReducer,
  createStandardAction,
  StateType
} from "typesafe-actions";

export type PagingActionType =
  | "CHANGE_INSIGHTS_CURSOR"
  | "CHANGE_USERS_CURSOR"
  | "CHANGE_DEVICE_USERS_CURSOR";

export const changeInsightsCursor = createStandardAction(
  "CHANGE_INSIGHTS_CURSOR"
)<string>();
export const changeUsersCursor = createStandardAction("CHANGE_USERS_CURSOR")<
  string | undefined
>();
export const changeDeviceUsersCursor = createStandardAction(
  "CHANGE_DEVICE_USERS_CURSOR"
)<string | undefined>();

const PagingActions = {
  changeInsightsCursor,
  changeUsersCursor,
  changeDeviceUsersCursor
};
export type PagingAction = ActionType<typeof PagingActions>;

export type PagingState = {
  insightsCursor: string;
  usersCursor: string | undefined;
  deviceUsersCursor: string | undefined;
};

export const defaultPagingState = {
  insightsCursor: undefined,
  usersCursor: undefined,
  deviceUsersCursor: undefined
};

export const PagingReducer = createReducer(defaultPagingState)
  .handleAction(changeInsightsCursor, (state, action) => ({
    ...state,
    insightsCursor: action.payload
  }))
  .handleAction(changeUsersCursor, (state, action) => ({
    ...state,
    usersCursor: action.payload
  }))
  .handleAction(changeDeviceUsersCursor, (state, action) => ({
    ...state,
    deviceUsersCursor: action.payload
  }));

export type PagingReducerState = StateType<typeof PagingReducer>;
